import React from "react";
import { useLocation, Link } from "react-router-dom";
import { formatMoney } from "../../utils/cartPricing";
import "./Success.css";

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.orderDetails;
  if (!order?._id) return <div className="order-success-container">
    <h1>Ingen orderbekräftelse att visa</h1>
    <p>Kontrollera din e-post eller dina beställningar om du nyligen har beställt.</p>
    <Link to="/my-order">Mina beställningar</Link>{" · "}<Link to="/">Till startsidan</Link>
  </div>;
  const address = order.shippingAddress || {};
  return <div className="order-success"><div className="order-success-container">
    <h1 className="order-heading">Beställning mottagen</h1>
    <p>Tack! Ditt ordernummer är <strong>{order.orderShortId || order._id}</strong>.</p>
    <div className="order-summary">
      <h2>Beställningssammanfattning</h2>
      <p><strong>Totalt:</strong> {formatMoney(order.totalAmount)}</p>
      <p><strong>Frakt:</strong> {formatMoney(order.deliveryCost)}</p>
      {Number(order.discount) > 0 && <p><strong>Rabatt:</strong> −{formatMoney(order.discount)}</p>}
      {order.orderStatus && <p><strong>Orderstatus:</strong> {order.orderStatus}</p>}
      {order.invoiceNumber && <p><strong>Fakturanummer:</strong> {order.invoiceNumber}</p>}
    </div>
    <div className="shipping-address"><h2>Leveransadress</h2>
      <p>{address.addressLine1}</p><p>{address.postalCode} {address.city}</p><p>{address.country?.toUpperCase()}</p>
    </div>
    <Link to="/" className="continue-shopping">Fortsätt handla</Link>
  </div></div>;
}
